import { render, staticRenderFns } from "./EleCarousel.vue?vue&type=template&id=1dcf4ada&scoped=true"
import script from "./EleCarousel.vue?vue&type=script&lang=js"
export * from "./EleCarousel.vue?vue&type=script&lang=js"
import style0 from "./EleCarousel.vue?vue&type=style&index=0&id=1dcf4ada&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcf4ada",
  null
  
)

export default component.exports